import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';

import {
    set_go_to_page,
    set_is_loading,
    set_first_type_portfolio_data,
} from '../../../../../actions';

import Project from "./Project";

import { PortfolioPage } from "../../../../../Constants/user";

import './style.scss';

class Jobs extends PureComponent {
    constructor(props) {
        super(props);

        const language = PortfolioPage.find(({ lang }) => lang === props.lang);

        this.state = {
            language,
            initialize: false,
        }
    }

    static getDerivedStateFromProps(props, state) {
        let language = PortfolioPage.find(({ lang }) => lang === props.lang);
        document.title = language.title;

        return {
            ...state,
            lang: props.lang,
            initialized: true,
            language,
        }
    }

    async componentDidMount() {
        const { profile, setFirstTypePortfolioData, setLoading } = this.props;

        if (!profile) {
            setLoading(true);
            const { data: { result, status } } = await axios.post('/api/portfolio/getAll');

            if (status) {
                setFirstTypePortfolioData(result);
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
            }
        }
        this.setState({
            initialize: true,
        })
    }

    goBack = () => {
        this.props.goToPage(0);
    };

    render() {
        const { language: { page1 }, initialize } = this.state;
        if (!initialize) return null;
        const { profile, lang } = this.props;

        return (
            <div id="mainPortfolio">
                <div className="name" dangerouslySetInnerHTML={{ __html: page1 }} />
                <div className="projects">
                    {profile.map(({ portfolioId, images, data }) => {
                        const mainImage = images.find(({ checked }) => checked === 1).src;
                        const currentData = data.find(({ language }) => lang === language);

                        return (
                            <Project
                                id={portfolioId}
                                {...currentData}
                                key={portfolioId}
                                mainImage={mainImage}
                            />
                        )
                    })}
                </div>
                <div className="backButton" onClick={this.goBack}>
                    <span><img src="/images/userPage/Icons/Rectangle.png" alt=""/></span>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ portfolio: { profile }, main: { lang } }) => ({
    lang,
    profile,
});

const mapDispatchToProps = dispatch => ({
    goToPage: page => dispatch(set_go_to_page(page)),
    setLoading: state => dispatch(set_is_loading(state)),
    setFirstTypePortfolioData: data => dispatch(set_first_type_portfolio_data(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Jobs);
